import React, { Component } from "react";
import axios from "axios";

class WarrantNoAccessForm extends Component {
    constructor() {
        super();
        this.state = {
            userInput: "",
            serverResponse: "",
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    handleInputChange(event) {
        this.setState({ userInput: event.target.value });
    }
    handleSubmit(event) {
        event.preventDefault();
        const specials = /[|:<>[\]{}`\\()';&#?]/;
        if (specials.test(this.state.userInput)) {
            this.setState({ serverResponse: "Invalid input" });
        } else {
            axios.post("/controlAdmin", { userInput: this.state.userInput }).then(response => {
                this.setState({ serverResponse: response.data.message });
            })
        }
    }
    render() {
        return (
            <div className="warrantNoAccessForm">
                <div className="warrantNoAccessForm__header">
                    <span>Add/Remove All Number Access</span>
                </div>
                <div className="warrantNoForm__response" hidden={!this.state.serverResponse}>
                    {this.state.serverResponse}
                </div>
                <form className="warrantNoAccessForm__form" onSubmit={this.handleSubmit}>
                    <label>Username to add/remove:&nbsp;
                    <input type="text" className="warrantNoAccessForm__input" value={this.state.userInput} onChange={this.handleInputChange}></input>
                    </label>
                    <br />
                    <input type="submit" value="Submit" className="warrantNoAccessForm__submit" />
                </form>
            </div>
        );
    }
}

export default WarrantNoAccessForm;